
import Clarity from "@microsoft/clarity";
import { useState } from "react";
import { Helmet } from "react-helmet";
import { CLARITY_PROJECT_ID } from "../../../project_config";
import Breadcrumb from "../../common/breadcrumb/Breadcrumb";
import Footer from "../../common/footer/Footer";
import Header from "../../common/header/Header";
import PaymentSection from "./payment/PaymentSection";

export default function PaymentList() {
	Clarity.init(CLARITY_PROJECT_ID);
	const [isDesktop] = useState(window.innerWidth > 768);
	const linkDataList = [
		{ label: "خانه", href: "/" },
		{ label: "پرداخت‌ها", href: "/payment_list/" },
	];

	return (
		<>
			<Helmet>
				<title>پرداخت‌ها | همراهتیم</title>
				<meta name="description" content="فهرست پرداخت‌های کاربر در همراهتیم" />
			</Helmet>

			<div className="bg-[#F0F6FC] min-h-screen flex flex-col justify-between">
				<div>
					<Header isDesktop={isDesktop} />
					<div className="bg-white">
						<div className={`${isDesktop ? "w-[1200px]" : ""} mx-auto`}>
							<Breadcrumb linkDataList={linkDataList} />
						</div>
					</div>
					<div
						className={`${isDesktop ? "max-w-[720px]" : "px-[10px]"} mx-auto flex flex-col pt-6 md:pt-8 pb-8`}
					>
						<PaymentSection />
					</div>
				</div>
				<div>
					<Footer isDesktop={isDesktop} />
				</div>
			</div>
		</>
	);
}
